import styled from 'styled-components';
import { MapPin } from 'ui/icons/contacts/MapPin';
import { PhoneCall } from 'ui/icons/contacts/PhoneCall';
import { spacing } from 'ui/theme';
import { usePhoneFormat } from 'utils/hooks/usePhoneFormat';
import { UserClientType } from '../../domain';
import { CLIENT_TYPE_ICONS } from '../constants';
import { SecondaryDetail } from './SecondaryDetail';
import { SecondaryDetailSkeleton } from './SecondaryDetailSkeleton';

const Wrapper = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: ${spacing.half} ${spacing.plusHalf};
`;

type SecondaryDetailsProps = {
  isLoading: boolean;
  location?: string;
  phoneNumber?: string;
  clientType?: UserClientType;
  clientName?: string;
};

export const SecondaryDetails = ({
  isLoading,
  clientType,
  clientName,
  location,
  phoneNumber,
}: SecondaryDetailsProps) => {
  const formattedPhone = usePhoneFormat(phoneNumber ?? '');

  if (isLoading) {
    return (
      <Wrapper>
        <SecondaryDetailSkeleton />
        <SecondaryDetailSkeleton />
        <SecondaryDetailSkeleton />
      </Wrapper>
    );
  }

  if (!location && !phoneNumber && !clientType && !clientName) {
    return null;
  }

  return (
    <Wrapper>
      {!!location && (
        <SecondaryDetail data-test="location-details" icon={MapPin} label={location} />
      )}
      {!!phoneNumber && <SecondaryDetail icon={PhoneCall} label={formattedPhone} />}
      {!!clientType && !!clientName && (
        <SecondaryDetail icon={CLIENT_TYPE_ICONS[clientType]} label={clientName} />
      )}
    </Wrapper>
  );
};
